<template>
    <div>
        <b-modal size="xl" :id="id" ref="finder" hide-footer :title="prefix + title">
            <ModalidadeContratoList @close="modalidadeContratoSelect" :title="prefix + title + ' >'" />
        </b-modal>
        <lg-form-input-finder v-model="localValue" fieldDescription="descricao" :label="label"
            invalidFeedback="Modalidade de Contrato deve ser informada!" description="" @handleClean="handleClear">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </div>
</template>

<script>
import ModalidadeContratoList from "@/modules/cadastros/modalidadecontrato/ModalidadeContratoList.vue";
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";

export default {
    name: "LgFinderPageModalidadeContrato",
    components: { LgFormInputFinder, ModalidadeContratoList },

    props: {
        id: {
            type: String,
            default: "finderModalidadeContrato",
        },
        value: Object,
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Modalidade de Contrato",
        },
        title: {
            type: String,
            default: "Modalidade de Contrato",

        }
    },

    data() {
        return {
            localValue: this.value,
        };
    },

    watch: {
        value(newValue) {
            this.localValue = newValue;
        },
        localValue(newValue) {
            this.$emit("input", newValue);
        },
    },

    methods: {
        async show() {
            await this.$refs.finder.show();
        },

        handleClear() {
            this.localValue = null;
            this.$emit("input", null);
        },

        modalidadeContratoSelect(item) {
            this.localValue = item;
            this.$emit("input", item);

            this.$refs.finder.hide();

        },
    },
};
</script>
